import axios from 'axios'

export default {
  generateApi () {
    const api = axios.create({
      baseURL: process.env.VUE_APP_BASE,
      headers: {
        'Content-Type': 'application/json'
      }
    })

    return api
  }
}
